'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('awardCopy', {
    url: '/award-copy/?snippet&url&imgSrc',
    templateUrl: '/views/award-copy.html',
    controller: 'AwardCopyCtrl',
    data: {
      hideNavigation: true,
    },
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set("Patient's Choice Award Code Snippet - Opencare");
      },
    },
  });
});

angular.module('ClinicApp').controller('AwardCopyCtrl', function($scope, $stateParams, $base64) {
  $scope.snippet = '';

  if ($stateParams.snippet) {
    try {
      // The snippet is a base64 encoded value.
      $scope.snippet = $base64.decode(decodeURIComponent($stateParams.snippet));
    } catch (_err) {
      // Silence is gold.
    }
  } else if ($stateParams.url && $stateParams.imgSrc) {
    // Build the snippet "manually" based on the given values.
    var url = decodeURIComponent($stateParams.url);
    var imgSrc = decodeURIComponent($stateParams.imgSrc);

    try {
      url = $base64.decode(url);
      imgSrc = $base64.decode(imgSrc);
    } catch (_err) {
      // Silence is gold.
    }

    $scope.snippet = '<a href="' + url + '"><img src="' + imgSrc + '" alt="Opencare Patient\'s Choice Award"></a>';
  }

  new window.ClipboardJS('.js-snippet-copy');

  $scope.copy = function() {
    $scope.copied = true;
  };
});
